import { API_KEY, API_URL_WITHOUT_USER } from "../../Utils/API";
import {
  getDispatch,
  getSnackbarSuccess,
  isLoadingAction,
} from "../../Utils/helper";
import { HttpUtil } from "../../Utils/http-utils";
import ROUTES from "../../Utils/routesConstants";
import {
  getToken,
  GET_PROVIDER_PORTAL_DETAIL,
  VIEW_DETAIL_PAGE,
  GET_TOTAL_COUNT,
  GET_VIEW_HISTORY,
  GET_TESTDETAIL_UPDATE_PAGE,
  GET_TESTDETAIL_NEW_PAGE,
  GET_PACKAGEDETAIL_UPDATE_PAGE,
  GET_PACKAGEDETAIL_NEW_PAGE,
  getNetworkMenuId,
  GET_FACILITY_TEST,
  GET_DETAIL_TYPE,
  GET_TESTDETAIL_NEW_PAGE_IBU,
  GET_TESTDETAIL_UPDATE_PAGE_IBU,
  GET_PACKAGEDETAIL_NEW_PAGE_IBU,
  GET_PACKAGEDETAIL_UPDATE_PAGE_IBU,
  GET_PROVIDER_UPLOAD_DOC,
} from "../../Utils/types";

export const getProviderProfileDetailAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/Network/GetAllProviderList`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId:
      getNetworkMenuId()?.url === ROUTES?.PROVIDER_PROFILE_DETAILS &&
      getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(
        GET_PROVIDER_PORTAL_DETAIL,
        res?.data?.results?.getAllProviderDetails,
        dispatch
      );
      getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRecords, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_PROVIDER_PORTAL_DETAIL, {}, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};
export const GetDetailTypeAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/Network/GetDetailType`;
  return HttpUtil.makeGET(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId:  getNetworkMenuId()?.url === ROUTES?.PROVIDER_PROFILE_DETAILS &&
    getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    getDispatch(GET_DETAIL_TYPE, res?.data?.results, dispatch);
  });
};
export const getStaffDetailPopupAction = (id, sessionId) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkVerification/GetAllStaffDetailsNetwork?TicketId=${id}&SessionId=${sessionId}`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      ApiKey: API_KEY,
      Authorization: getToken(),
      MenuId:
        getNetworkMenuId()?.url === ROUTES?.PROVIDER_PROFILE_DETAILS &&
        getNetworkMenuId()?.menuId,
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(VIEW_DETAIL_PAGE, res?.data?.results, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getSnackbarSuccess("error", res?.data?.message, dispatch);
      getDispatch(VIEW_DETAIL_PAGE, {}, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const getTestDetailNewPopupAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkVerification/GetProviderSKUTestDetailsNetwork`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId:
      getNetworkMenuId()?.url === ROUTES?.PROVIDER_PROFILE_DETAILS &&
      getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_TESTDETAIL_NEW_PAGE, res?.data?.results, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getSnackbarSuccess("error", res?.data?.message, dispatch);
      getDispatch(GET_TESTDETAIL_NEW_PAGE, [], dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const getTestDetailUpdatePopupAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkVerification/GetProviderSKUTestDetailsNetwork`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId:
      getNetworkMenuId()?.url === ROUTES?.PROVIDER_PROFILE_DETAILS &&
      getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_TESTDETAIL_UPDATE_PAGE, res?.data?.results, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getSnackbarSuccess("error", res?.data?.message, dispatch);
      getDispatch(GET_TESTDETAIL_UPDATE_PAGE, [], dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const getPackageDetailNewPopupAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkVerification/GetProviderPackageDetailsNetwork`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId:
      getNetworkMenuId()?.url === ROUTES?.PROVIDER_PROFILE_DETAILS &&
      getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_PACKAGEDETAIL_NEW_PAGE, res?.data?.results, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getSnackbarSuccess("error", res?.data?.message, dispatch);
      getDispatch(GET_PACKAGEDETAIL_NEW_PAGE, [], dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};
export const getPackageDetailUpdatePopupAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkVerification/GetProviderPackageDetailsNetwork`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId:
      getNetworkMenuId()?.url === ROUTES?.PROVIDER_PROFILE_DETAILS &&
      getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_PACKAGEDETAIL_UPDATE_PAGE, res?.data?.results, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getSnackbarSuccess("error", res?.data?.message, dispatch);
      getDispatch(GET_PACKAGEDETAIL_UPDATE_PAGE, [], dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const getPaymentDetailPopupAction = (id, sessionId) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkVerification/GetPaymentDetailsNetwork?TicketId=${id}&SessionId=${sessionId}`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      ApiKey: API_KEY,
      Authorization: getToken(),
      MenuId:
        getNetworkMenuId()?.url === ROUTES?.PROVIDER_PROFILE_DETAILS &&
        getNetworkMenuId()?.menuId,
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(VIEW_DETAIL_PAGE, res?.data?.results, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getSnackbarSuccess("error", res?.data?.message, dispatch);
      getDispatch(VIEW_DETAIL_PAGE, {}, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const getProfileDetailPopupAction = (id, sessionId) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkVerification/GetProfileDetailsNetwork?TicketId=${id}&SessionId=${sessionId}`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      ApiKey: API_KEY,
      Authorization: getToken(),
      MenuId:
        getNetworkMenuId()?.url === ROUTES?.PROVIDER_PROFILE_DETAILS &&
        getNetworkMenuId()?.menuId,
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(VIEW_DETAIL_PAGE, res?.data?.results, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getSnackbarSuccess("error", res?.data?.message, dispatch);
      getDispatch(VIEW_DETAIL_PAGE, {}, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const getProfileVerificationPopupAction =
  (id, sessionId) => (dispatch) => {
    isLoadingAction(true, dispatch);
    const url = `${API_URL_WITHOUT_USER}/NetworkVerification/GetProfileVerificationDetailsNetwork?ticketId=${id}&SessionId=${sessionId}`;
    return HttpUtil.makeGET(
      url,
      {},
      {
        ApiKey: API_KEY,
        Authorization: getToken(),
        MenuId:
          getNetworkMenuId()?.url === ROUTES?.PROVIDER_PROFILE_DETAILS &&
          getNetworkMenuId()?.menuId,
      }
    ).then((res) => {
      if (res?.data?.status === true) {
        getDispatch(VIEW_DETAIL_PAGE, res?.data?.results, dispatch);
        isLoadingAction(false, dispatch);
      } else {
        getSnackbarSuccess("error", res?.data?.message, dispatch);
        getDispatch(VIEW_DETAIL_PAGE, {}, dispatch);
        isLoadingAction(false, dispatch);
      }
    });
  };

export const getInfrastructureDetailPopupAction =
  (id, sessionId) => (dispatch) => {
    isLoadingAction(true, dispatch);
    const url = `${API_URL_WITHOUT_USER}/NetworkVerification/GetInfrastructureDetailsNetwork?ticketId=${id}&SessionId=${sessionId}`;
    return HttpUtil.makeGET(
      url,
      {},
      {
        ApiKey: API_KEY,
        Authorization: getToken(),
        MenuId:
          getNetworkMenuId()?.url === ROUTES?.PROVIDER_PROFILE_DETAILS &&
          getNetworkMenuId()?.menuId,
      }
    ).then((res) => {
      if (res?.data?.status === true) {
        getDispatch(VIEW_DETAIL_PAGE, res?.data?.results, dispatch);
        isLoadingAction(false, dispatch);
      } else {
        getSnackbarSuccess("error", res?.data?.message, dispatch);
        getDispatch(VIEW_DETAIL_PAGE, {}, dispatch);
        isLoadingAction(false, dispatch);
      }
    });
  };

export const approveRejectAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/ApprovalProcess/ProviderApproval`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId:
      getNetworkMenuId()?.url === ROUTES?.PROVIDER_PROFILE_DETAILS &&
      getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      isLoadingAction(false, dispatch);
      getSnackbarSuccess("success", res?.data?.message, dispatch);
    } else {
      isLoadingAction(false, dispatch);
      getSnackbarSuccess("error", res?.data?.message, dispatch);
    }
  });
};
export const approveRejectTestDetailsAction =
  (e, handleClose) => (dispatch) => {
    isLoadingAction(true, dispatch);
    const url = `${API_URL_WITHOUT_USER}/ApprovalProcess/ProviderApprovalForSkuPackage`;
    return HttpUtil.makePOST(url, e, {
      ApiKey: API_KEY,
      Authorization: getToken(),
      MenuId:
        getNetworkMenuId()?.url === ROUTES?.PROVIDER_PROFILE_DETAILS &&
        getNetworkMenuId()?.menuId,
    }).then((res) => {
      if (res?.data?.status === true) {
        isLoadingAction(false, dispatch);
        getSnackbarSuccess("success", res?.data?.message, dispatch);
      } else {
        isLoadingAction(false, dispatch);
        handleClose();
        getSnackbarSuccess("error", res?.data?.message, dispatch);
      }
    });
  };

export const getViewHistoryAction = (id, sessionId) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkVerification/GetProviderPortalTicketHistoryNetwork?ticketId=${id}&SessionId=${sessionId}`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      ApiKey: API_KEY,
      Authorization: getToken(),
      MenuId:
        getNetworkMenuId()?.url === ROUTES?.PROVIDER_PROFILE_DETAILS &&
        getNetworkMenuId()?.menuId,
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_VIEW_HISTORY, res?.data?.results, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_VIEW_HISTORY, {}, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const getFacilityListAction = (type, providerID) => (dispatch) => {
  // isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkVerification/GetFacilityList`;
  return HttpUtil.makePOST(
    url,
    {
      facilityId: 0,
      facilityName: "",
      facilityType: type,
      providerID: providerID || 0,
    },
    {
      ApiKey: API_KEY,
      Authorization: getToken(),
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_FACILITY_TEST, res?.data?.results, dispatch);
      // isLoadingAction(false, dispatch);
    } else {
      getSnackbarSuccess("error", res?.data?.message, dispatch);
      getDispatch(GET_FACILITY_TEST, {}, dispatch);
      // isLoadingAction(false, dispatch);
    }
  });
};

export const getPackageWiseClientsDetailsNetworkAction = (id) => (dispatch) => {
  const url = `${API_URL_WITHOUT_USER}/NetworkVerification/GetPackageWiseClientsDetailsNetwork?PackageId=${id}`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      Authorization: getToken(),
      MenuId: getNetworkMenuId()?.menuId,
    }
  );
};

// For Test & Package approval for IBU Rate update ///

export const getTestDetailNewPopupActionIBU = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkVerification/GetProviderSKUTestDetailsNetworkIBU`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId:
      getNetworkMenuId()?.url === ROUTES?.PROVIDER_PROFILE_DETAILS &&
      getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      console.log("res?.data?.results",res?.data?.results)
      getDispatch(GET_TESTDETAIL_NEW_PAGE_IBU, res?.data?.results, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getSnackbarSuccess("error", res?.data?.message, dispatch);
      getDispatch(GET_TESTDETAIL_NEW_PAGE_IBU, [], dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const getTestDetailUpdatePopupActionIBU = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkVerification/GetProviderSKUTestDetailsNetworkIBU`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId:
      getNetworkMenuId()?.url === ROUTES?.PROVIDER_PROFILE_DETAILS &&
      getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_TESTDETAIL_UPDATE_PAGE_IBU, res?.data?.results, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getSnackbarSuccess("error", res?.data?.message, dispatch);
      getDispatch(GET_TESTDETAIL_UPDATE_PAGE_IBU, [], dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const approveRejectTestDetailsActionIBU = (e, handleClose) => (dispatch) => {
    isLoadingAction(true, dispatch);
    const url = `${API_URL_WITHOUT_USER}/ApprovalProcess/ProviderApprovalForSkuPackageIBU`;
    return HttpUtil.makePOST(url, e, {
      ApiKey: API_KEY,
      Authorization: getToken(),
      MenuId:
        getNetworkMenuId()?.url === ROUTES?.PROVIDER_PROFILE_DETAILS &&
        getNetworkMenuId()?.menuId,
    }).then((res) => {
      if (res?.data?.status === true) {
        isLoadingAction(false, dispatch);
        getSnackbarSuccess("success", res?.data?.message, dispatch);
      } else {
        isLoadingAction(false, dispatch);
        handleClose();
        getSnackbarSuccess("error", res?.data?.message, dispatch);
      }
    });
};

export const getPackageDetailNewPopupActionIBU = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkVerification/GetProviderPackageDetailsNetworkIBU`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId:
      getNetworkMenuId()?.url === ROUTES?.PROVIDER_PROFILE_DETAILS &&
      getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_PACKAGEDETAIL_NEW_PAGE_IBU, res?.data?.results, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getSnackbarSuccess("error", res?.data?.message, dispatch);
      getDispatch(GET_PACKAGEDETAIL_NEW_PAGE_IBU, [], dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};
export const getPackageDetailUpdatePopupActionIBU = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkVerification/GetProviderPackageDetailsNetworkIBU`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId:
      getNetworkMenuId()?.url === ROUTES?.PROVIDER_PROFILE_DETAILS &&
      getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_PACKAGEDETAIL_UPDATE_PAGE_IBU, res?.data?.results, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getSnackbarSuccess("error", res?.data?.message, dispatch);
      getDispatch(GET_PACKAGEDETAIL_UPDATE_PAGE_IBU, [], dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const getProviderUploadDocuemntActionIBU = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkVerification/GetProviderDocumentNetworkIBU`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId:
      getNetworkMenuId()?.url === ROUTES?.PROVIDER_PROFILE_DETAILS &&
      getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      console.log("res?.data?.results",res?.data?.results)
      getDispatch(GET_PROVIDER_UPLOAD_DOC, res?.data?.results, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getSnackbarSuccess("error", res?.data?.message, dispatch);
      getDispatch(GET_PROVIDER_UPLOAD_DOC, [], dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const approveRejectProviderUploadDocActionIBU = (e, handleClose) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/ApprovalProcess/ProviderApprovalForUploadDocumentIBU`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId:
      getNetworkMenuId()?.url === ROUTES?.PROVIDER_PROFILE_DETAILS &&
      getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      isLoadingAction(false, dispatch);
      getSnackbarSuccess("success", res?.data?.message, dispatch);
    } else {
      isLoadingAction(false, dispatch);
      handleClose();
      getSnackbarSuccess("error", res?.data?.message, dispatch);
    }
  });
};



